import { render, staticRenderFns } from "./amountStatistic.vue?vue&type=template&id=4989974e&scoped=true"
import script from "./amountStatistic.vue?vue&type=script&lang=js"
export * from "./amountStatistic.vue?vue&type=script&lang=js"
import style0 from "./amountStatistic.vue?vue&type=style&index=0&id=4989974e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989974e",
  null
  
)

export default component.exports